import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import cookie from 'react-cookies'

import {
  getUserData,
  patchUserData,
  patchUserWatchedIntro,
} from '../../Api/backendApi'
import LoginScreen from './WelcomeScreen'

class LoginScreenContainer extends Component {
  state = {
    user: {},
  }
  componentDidMount = async () => {
    await this.userData()
  }

  userData = async () => {
    const result = await getUserData()

    this.setState({
      user: result,
    })
  }

  videoStart = (e) => {
    e.target.paused ? e.target.play() : e.target.pause()
  }

  redirectTo = (destination) => {
    this.props.history.push(destination)
  }

  videoWatched = () => {
    // cookie.save('userWatchedWelcomeVideo', true)
    patchUserWatchedIntro(false, this.state.user.id)
    setTimeout(() => {
      this.props.history.push('/')
    }, 2000)
  }

  render() {
    return (
      <LoginScreen
        videoStart={this.videoStart}
        redirectTo={this.redirectTo}
        videoWatched={this.videoWatched}
      />
    )
  }
}
export default withRouter(LoginScreenContainer)
